import { UploadCloud, Cpu, Trophy, ArrowRight } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";

const ICONS = [UploadCloud, Cpu, Trophy];

export default function Solution() {
    const { t } = useI18n();
    const s = t.solution;
    return (
        <section
            id="solution"
            data-testid="solution-section"
            className="relative py-24 md:py-32 border-t border-white/5 overflow-hidden"
        >
            <div
                className="absolute -right-40 top-20 w-[600px] h-[600px] rounded-full pointer-events-none"
                style={{
                    background:
                        "radial-gradient(closest-side, rgba(212,255,0,0.08), transparent 70%)",
                }}
                aria-hidden
            />
            <div className="relative max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="max-w-4xl mb-16 reveal">
                    <div className="text-xs tracking-[0.22em] uppercase font-bold text-[#D4FF00] mb-4">
                        {s.tag}
                    </div>
                    <h2 className="font-display font-bold uppercase text-4xl md:text-5xl lg:text-6xl tracking-tighter heading-clamp">
                        {s.headline}{" "}
                        <span className="text-[#D4FF00]">{s.headlineAccent}</span>
                    </h2>
                </div>

                <div className="grid lg:grid-cols-3 gap-5 md:gap-6 relative">
                    {s.steps.map((step, i) => {
                        const Icon = ICONS[i];
                        return (
                            <div
                                key={step.n}
                                data-testid={`solution-step-${i}`}
                                className="card-hover relative rounded-2xl border border-white/10 bg-[#071B12] p-7 md:p-8 reveal"
                                style={{ transitionDelay: `${i * 100}ms` }}
                            >
                                <div className="flex items-start justify-between mb-8">
                                    <div className="font-display text-6xl font-bold text-[#D4FF00] tabular leading-none">
                                        {step.n}
                                    </div>
                                    <div className="h-14 w-14 rounded-xl bg-[#04140D] border border-white/10 grid place-items-center">
                                        <Icon size={24} className="text-white" />
                                    </div>
                                </div>
                                <h3 className="font-display font-bold uppercase text-2xl md:text-[28px] text-white mb-3 tracking-tight">
                                    {step.title}
                                </h3>
                                <p className="text-white/65 leading-relaxed text-[15px] min-h-[100px]">
                                    {step.body}
                                </p>
                                <div className="mt-6 pt-5 border-t border-white/5 flex items-center justify-between">
                                    <span className="text-[11px] tracking-widest uppercase text-white/45 font-semibold">
                                        {step.meta}
                                    </span>
                                    {i < s.steps.length - 1 && (
                                        <ArrowRight
                                            size={18}
                                            className="text-[#D4FF00] hidden lg:block"
                                        />
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="mt-12 rounded-2xl border border-white/10 bg-[#071B12] p-6 md:p-8 reveal">
                    <div className="grid md:grid-cols-3 gap-6 items-center">
                        <div className="font-mono text-xs text-white/55 bg-[#04140D] border border-white/5 rounded-lg p-4 overflow-hidden">
                            <div className="text-[#D4FF00] text-[10px] uppercase tracking-widest mb-2">
                                {s.csvLabel}
                            </div>
                            point_no,server,serve,result
                            <br />
                            1,P1,1st,winner
                            <br />
                            2,P1,1st,unforced_err
                            <br />
                            3,P2,2nd,ace
                            <br />
                            4,P1,1st,rally_won
                        </div>
                        <div className="flex md:justify-center">
                            <div className="px-4 py-2 rounded-full bg-[#D4FF00]/10 border border-[#D4FF00]/30 text-[#D4FF00] text-xs uppercase tracking-widest font-bold">
                                {s.engine}
                            </div>
                        </div>
                        <div className="grid grid-cols-2 gap-3">
                            {[
                                ["S.E.M.", "57.54%"],
                                ["R.E.M.", "41.89%"],
                                ["P1", "63.12%"],
                                ["Lead", "51.25%"],
                            ].map(([k, v]) => (
                                <div
                                    key={k}
                                    className="rounded-lg bg-[#04140D] border border-white/5 px-3 py-2.5"
                                >
                                    <div className="text-[10px] uppercase tracking-widest text-white/45">
                                        {k}
                                    </div>
                                    <div className="font-display font-bold text-lg tabular text-[#D4FF00]">
                                        {v}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
